import Vue from "vue";

/**
 * Preferências de interface do usuário (tema claro/escuro e menu recolhido).
 *
 * Ficam só no navegador (localStorage), por aparelho: são conforto visual, não
 * dado de negócio. O estado é reativo (Vue.observable) para a barra superior e
 * o menu lateral reagirem juntos à mesma troca.
 *
 * A aplicação é feita em atributos/classes do documento, que é onde o SCSS
 * enxerga:
 *   <html data-theme="dark">      → design/custom/_dark.scss
 *   <body class="vertical-collpsed"> → menu recolhido (design/custom/structure/_vertical.scss)
 */

const CHAVE_TEMA = "st-tema";
const CHAVE_MENU = "st-menu-recolhido";

function ler(chave) {
  try {
    return localStorage.getItem(chave);
  } catch (e) {
    return null;
  }
}

function gravar(chave, valor) {
  try {
    localStorage.setItem(chave, valor);
  } catch (e) {
    /* modo privado / armazenamento bloqueado: a preferência vale só nesta aba */
  }
}

export const preferenciasUi = Vue.observable({
  tema: ler(CHAVE_TEMA) === "dark" ? "dark" : "light",
  menuRecolhido: ler(CHAVE_MENU) === "1",
});

export function aplicarTema() {
  document.documentElement.setAttribute("data-theme", preferenciasUi.tema);
}

export function alternarTema() {
  // Troca sem animar tudo de uma vez: a classe desliga as transições por um
  // quadro, senão cada card/botão "desbota" em tempos diferentes.
  document.documentElement.classList.add("st-trocando-tema");
  preferenciasUi.tema = preferenciasUi.tema === "dark" ? "light" : "dark";
  gravar(CHAVE_TEMA, preferenciasUi.tema);
  aplicarTema();
  window.setTimeout(() => document.documentElement.classList.remove("st-trocando-tema"), 60);
}

/**
 * O body tem a classe trocada por cada layout (`document.body.className =
 * 'main'` no beforeCreate do layout), então o "recolhido" é reaplicado pelo
 * layout ao montar, e não só uma vez no boot.
 */
export function aplicarMenuRecolhido() {
  document.body.classList.toggle("vertical-collpsed", preferenciasUi.menuRecolhido);
}

export function alternarMenuRecolhido(valor) {
  preferenciasUi.menuRecolhido = typeof valor === "boolean" ? valor : !preferenciasUi.menuRecolhido;
  gravar(CHAVE_MENU, preferenciasUi.menuRecolhido ? "1" : "0");
  aplicarMenuRecolhido();
}

/** Chamado no boot (main.js), antes do $mount, para não piscar o tema claro. */
export function iniciarPreferenciasUi() {
  aplicarTema();
}
